import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMatDatetimePickerModule } from '@angular-material-components/datetime-picker';
import { MaterialModule } from '../../material.module';
import { DateOnlyFormatModule } from '../date-only-format/date-only-format.module';
import { DynamicFormComponent } from './dynamic-form.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    // Directives only; the adapter and formats are provided once in AppModule.
    NgxMatDatetimePickerModule,
    DateOnlyFormatModule,
  ],
  declarations: [
    DynamicFormComponent,
  ],
  exports: [
    DynamicFormComponent,
  ],
})
export class DynamicFormModule {}
